<template>
	<component
    :is="tag"
    class="btn"
    :href="url || href"
    :type="!url && type"
    :target="url || href ? target : null"
    :disabled="disabled"
    :class="[
			`btn--${level}`,
      ...variants.map(variant => `btn--${variant}`),
      { 'btn--icon': icon },
      { 'btn--arrow': arrow },
      { 'btn--no-text': !text },
      { 'btn--reverse': reverse },
    ]"
    @click="onClick"
  >
		<component
      class="btn__icon"
			v-if="icon"
			:is="iconComponent(icon)"
		/>
    <span
      class="btn__text"
      v-if="text"
      v-html="text"
    />
		<component
      class="btn__arrow"
			v-if="arrow"
			:is="arrowComponent"
		/>
  </component>
</template>

<script>
import {toPascal} from '@/utils/convertcase';

export default {
	props: {
		disabled: Boolean,
		href: String,
		target: String,
		url: String,
		type: String,
		icon: String,
		text: String,
		arrow: Boolean,
		reverse: Boolean,
		level: {
			type: String,
			default: 'primary',
		},
		variants: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			tag: this.url || this.href ? 'a' : 'button'
		};
	},
	computed: {
		arrowComponent() {
			const icon = this.reverse ? 'mid-circle-chevron-left' : 'mid-circle-chevron-right';
			return `SVG${toPascal(icon)}`;
		},
	},
	methods: {
		onClick(e) {
			this.$emit('click', e);
		}
	}
}
</script>

<style>

</style>